import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const ShipmentBillAPI = createApi({
  reducerPath: "ShipmentBillAPI",
  baseQuery,
  tagTypes: ["ShipmentBill"],
  endpoints: (builder) => ({

    createShipmentBill: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/shipment/billPrint/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {billPrint : data},  
      }),
      invalidatesTags: ["ShipmentBill"],
    }),
    
      // 🔹 Get all invoices by masterId
      getShipmentBillById: builder.query({
        query: ({id}) => `/export/shipment/billPrint/${id}`,
        transformResponse: (response) => response?.data ?? [],
        providesTags: ["ShipmentBill"],
      }),
    
  }),
});

export const {
  useCreateShipmentBillMutation,
  useLazyGetShipmentBillByIdQuery,
} = ShipmentBillAPI;
